var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowRightWhiteIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16.63 16.21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-100{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 69114",
    className: "cls-100",
    d: "M7.07,1.09a.88.88,0,0,0,0,1.25l0,0,4.48,4.26H.89A.89.89,0,0,0,0,7.51H0V8.7a.88.88,0,0,0,.88.89H11.56L7.08,13.85a.9.9,0,0,0,0,1.26h0l.82.83a.91.91,0,0,0,1.26,0h0l7.22-7.22a.89.89,0,0,0,0-1.25h0L9.15.26A.88.88,0,0,0,7.9.26h0Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightWhiteIcon);
export default __webpack_public_path__ + "static/media/ArrowRightWhiteIcon.f69fb3716769e2a754231323672e1052.svg";
export { ForwardRef as ReactComponent };